var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgIconOtherDirection = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 10,
  height: 10,
  viewBox: "0 0 16 16"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  d: "M6.519 9.351 1.878 7.415a.484.484 0 0 1 0-.9l11.617-4.783a.484.484 0 0 1 .629.629l-4.8 11.632a.484.484 0 0 1-.9 0Z",
  "data-name": "Path 5472"
})));
export { SvgIconOtherDirection as ReactComponent };
export default "/_next/static/images/icon_other_direction.svg";